// extracted by mini-css-extract-plugin
export var thumbSlider = "ThumbSlider-module--thumbSlider--UWwFB";
export var thumbSlide = "ThumbSlider-module--thumbSlide--oSDnA";